import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i15 from 'cover-letter-library';
import { CoverLetterLibraryComponent, CoverLetterLibraryModule } from 'cover-letter-library';
import * as i16 from 'support-letter-library';
import { SupportLetterLibraryComponent, SupportLetterLibraryModule } from 'support-letter-library';
import * as i7 from 'place-holder-library';
import { PlaceHolderDirective, PlaceHolderLibraryModule } from 'place-holder-library';
import * as i2 from 'dirty-check-store';
import { MarkCleanFormAction } from 'dirty-check-store';
import { first } from 'rxjs/internal/operators/first';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DocumentChecklistNewLibraryComponent, DocumentChecklistNewLibraryModule } from 'document-checklist-new-library';
import * as i14 from 'generate-forms-new-library';
import { GenerateFormsNewLibraryComponent, GenerateFormsNewLibraryModule } from 'generate-forms-new-library';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i8 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i9 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i10 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i11 from 'primeng/divider';
import * as i12 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i13 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { PrimengLibraryModule } from 'primeng-library';
import { OrganizeDocumentsLibraryModule } from 'organize-documents-library';

class LetterGenerationLibraryService {
    constructor() { }
}
LetterGenerationLibraryService.ɵfac = function LetterGenerationLibraryService_Factory(t) { return new (t || LetterGenerationLibraryService)(); };
LetterGenerationLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LetterGenerationLibraryService, factory: LetterGenerationLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function LetterGenerationLibraryComponent_div_1_li_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 24);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r12.inputData.caseType != "I130" ? ctx_r12.inputData.visatype : ctx_r12.inputData.caseType)("stepDetails", ctx_r12.stepDetails)("isViewMode", ctx_r12.inputData["isViewMode"])("isCaseRequest", ctx_r12.inputData["isCaseRequest"]);
} }
const _c0 = function (a0) { return { "layoutCode": a0 }; };
function LetterGenerationLibraryComponent_div_1_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 26);
    i0.ɵɵelement(1, "lib-maximize-dialog-library", 27);
    i0.ɵɵelementStart(2, "i", 28);
    i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_div_1_li_10_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(1, _c0, ctx_r13.inputData == null ? null : ctx_r13.inputData.layoutCode));
} }
function LetterGenerationLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Add details for letter generation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵtemplate(9, LetterGenerationLibraryComponent_div_1_li_9_Template, 2, 4, "li", 22);
    i0.ɵɵtemplate(10, LetterGenerationLibraryComponent_div_1_li_10_Template, 3, 3, "li", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.primaryData.stepName);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizard);
} }
function LetterGenerationLibraryComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 32);
    i0.ɵɵtext(5, "Add details for letter generation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r16.primaryData.stepName);
} }
function LetterGenerationLibraryComponent_div_2_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 24);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r17.inputData.caseType != "I130" ? ctx_r17.inputData.visatype : ctx_r17.inputData.caseType)("stepDetails", ctx_r17.stepDetails)("isViewMode", ctx_r17.inputData["isViewMode"])("isCaseRequest", ctx_r17.inputData["isCaseRequest"]);
} }
function LetterGenerationLibraryComponent_div_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "lib-maximize-dialog-library", 27);
    i0.ɵɵelementStart(2, "i", 28);
    i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_div_2_ng_container_6_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(1, _c0, ctx_r18.inputData == null ? null : ctx_r18.inputData.layoutCode));
} }
function LetterGenerationLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, LetterGenerationLibraryComponent_div_2_div_1_Template, 6, 1, "div", 30);
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵelementStart(3, "ul");
    i0.ɵɵtemplate(4, LetterGenerationLibraryComponent_div_2_li_4_Template, 2, 4, "li", 22);
    i0.ɵɵelementStart(5, "li", 26);
    i0.ɵɵtemplate(6, LetterGenerationLibraryComponent_div_2_ng_container_6_Template, 3, 3, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
} }
function LetterGenerationLibraryComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "lib-assigning-task-library", 33);
    i0.ɵɵlistener("updateStatus", function LetterGenerationLibraryComponent_ng_container_5_Template_lib_assigning_task_library_updateStatus_1_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r2.inputData.visatype)("stepDetails", ctx_r2.stepDetails)("isViewMode", ctx_r2.inputData["isViewMode"])("isCaseRequest", ctx_r2.inputData["isCaseRequest"]);
} }
function LetterGenerationLibraryComponent_p_divider_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 34);
} }
function LetterGenerationLibraryComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "lib-last-update-library", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputDetails", ctx_r4.stepDetails)("primaryData", ctx_r4.inputData)("sectionCode", ctx_r4.sectionCode);
} }
const _c1 = function (a0, a1) { return { "activeItem": a0, "inActiveItem": a1 }; };
function LetterGenerationLibraryComponent_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_a_16_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.handleCoverLetterSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Cover Letter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r5.selectedItem === 1, ctx_r5.selectedItem !== 1));
} }
function LetterGenerationLibraryComponent_a_17_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_a_17_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.handleSupoortLetterSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Support Letter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r6.selectedItem === 2, ctx_r6.selectedItem !== 2));
} }
function LetterGenerationLibraryComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_a_18_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.handleOrganizeDocumentSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Organize Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r7.selectedItem === 3, ctx_r7.selectedItem !== 3));
} }
function LetterGenerationLibraryComponent_ng_template_20_Template(rf, ctx) { }
function LetterGenerationLibraryComponent_div_21_lib_generate_forms_new_library_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-generate-forms-new-library", 42);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("inputData", ctx_r29.inputData);
} }
function LetterGenerationLibraryComponent_div_21_cover_letter_library_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "cover-letter-library", 43);
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("primaryData", ctx_r30.inputData);
} }
function LetterGenerationLibraryComponent_div_21_support_letter_library_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "support-letter-library", 43);
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("primaryData", ctx_r31.inputData);
} }
const _c2 = function (a0) { return { "displayNone": a0 }; };
function LetterGenerationLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "mat-tab-group", 36);
    i0.ɵɵlistener("selectedTabChange", function LetterGenerationLibraryComponent_div_21_Template_mat_tab_group_selectedTabChange_1_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.onSelectedTabChange($event); });
    i0.ɵɵelementStart(2, "mat-tab", 37);
    i0.ɵɵtemplate(3, LetterGenerationLibraryComponent_div_21_lib_generate_forms_new_library_3_Template, 1, 1, "lib-generate-forms-new-library", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-tab", 39);
    i0.ɵɵtemplate(5, LetterGenerationLibraryComponent_div_21_cover_letter_library_5_Template, 1, 1, "cover-letter-library", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-tab", 41);
    i0.ɵɵtemplate(7, LetterGenerationLibraryComponent_div_21_support_letter_library_7_Template, 1, 1, "support-letter-library", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2, !ctx_r9.isWizard));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.tmpIndex == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.tmpIndex == 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.tmpIndex == 2);
} }
function LetterGenerationLibraryComponent_ng_container_22_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "div", 45);
    i0.ɵɵelementStart(2, "div", 46);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelement(4, "lib-step-status-update-component-library", 47);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("stepDetails", ctx_r34.stepDetails)("visaType", ctx_r34.inputData.caseType != "I130" ? ctx_r34.inputData.visatype : ctx_r34.inputData.caseType)("type", ctx_r34.typeOfButton)("showPreviousStepBtn", true)("showNextStepBtn", true);
} }
function LetterGenerationLibraryComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LetterGenerationLibraryComponent_ng_container_22_div_1_Template, 5, 5, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.isLastTab);
} }
function LetterGenerationLibraryComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelementStart(1, "span", 48);
    i0.ɵɵelement(2, "i", 49);
    i0.ɵɵtext(3, "This step can be marked complete when you reach the last tab, i.e., Organize Documents ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class LetterGenerationLibraryComponent {
    constructor(store, componentFactoryResolver, guard, toastr, stepStatusUpdatePayloadCostruction, appServicesLibraryService) {
        this.store = store;
        this.componentFactoryResolver = componentFactoryResolver;
        this.guard = guard;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.showSupportLetterSection = true;
        this.showOrganizedSection = true;
        this.showCoverLetterSection = true;
        this.isWizard = false;
        this.onDialogClose = new EventEmitter();
        this.tmpIndex = 0;
        this.selectedItem = 0;
        this.isLastTab = false;
        this.sectionCode = '';
    }
    ngOnInit() {
        this.isSimplifyH1b = this.simplifyH1b;
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
        this.inputData = this.primaryData;
        // this.showSupportLetterSection = this.primaryData.visatype === 'APPLADCARDNONIM' || this.primaryData.immigrationClassification === "APPLADCARDIMM"? false : true;
        //this.showOrganizedSection = this.primaryData.visatype === 'APPLADCARDNONIM' || this.primaryData.immigrationClassification === "APPLADCARDIMM" ? false : true;
        if (!this.isWizard) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction == 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                this.toggleControlsStatus();
                if (this.selectedItem === 0) {
                    this.handleFormsGeneration();
                }
                if (this.stepDetails) {
                    this.handleShowGenerateFormTabS();
                }
                // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                //   this.updateStepStatus('INPROGRESS');
                // }
            });
        }
        else {
            if (this.selectedItem === 0) {
                this.handleCoverLetterSelection();
            }
        }
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    loadComponent(component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const viewContainerRef = this.placeHolder.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.primaryData = this.inputData;
        componentRef.instance.inputData = this.inputData;
    }
    onSelectedTabChange(event) {
        let index = event.index;
        /**
         * For Refreshing the component again
         */
        this.tmpIndex = index;
        if (index == 0) {
            this.handleFormsGeneration();
        }
        else if (index == 1) {
            this.handleCoverLetterSelection();
        }
        else if (index == 2) {
            this.handleSupoortLetterSelection();
        }
        else {
            this.handleOrganizeDocumentSelection();
        }
    }
    handleFormsGeneration() {
        this.sectionCode = 'GEN_FORMS';
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = false;
                this.selectedItem = 0;
                // this.loadComponent(GenerateFormsLibraryComponent);
                this.loadComponent(GenerateFormsNewLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handleCoverLetterSelection() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_FILL_FORM';
        }
        else {
            this.sectionCode = 'COVLTR';
        }
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                // this.isLastTab = false;
                this.isLastTab = this.primaryData.visatype === 'APPLADCARDNONIM' || this.primaryData.immigrationClassification === "APPLADCARDIMM";
                this.selectedItem = 1;
                this.loadComponent(CoverLetterLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handleSupoortLetterSelection() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_FILL_FORM';
        }
        else {
            this.sectionCode = 'SUPLTR';
        }
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = false;
                this.selectedItem = 2;
                this.loadComponent(SupportLetterLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handleOrganizeDocumentSelection() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_FILL_FORM';
        }
        else {
            this.sectionCode = 'ORG_DOC';
        }
        this.isLastTab = true;
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = true;
                this.selectedItem = 3;
                // this.loadComponent(OrganizeDocumentsLibraryComponent);
                this.loadComponent(DocumentChecklistNewLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    handleShowGenerateFormTabS() {
        if (this.inputData.filingType && this.inputData.filingType === 'e-filing') {
            if (this.stepDetails && this.stepDetails.additionalConfig && JSON.parse(this.stepDetails.additionalConfig).generateEfilingLetterConfig) {
                let generateEfilingLetterConfig = JSON.parse(this.stepDetails.additionalConfig).generateEfilingLetterConfig;
                this.showCoverLetterSection = (generateEfilingLetterConfig.find(x => x.name === 'Show Cover Letter')).value;
                this.showSupportLetterSection = (generateEfilingLetterConfig.find(x => x.name === 'Show Support Letter')).value;
                this.showOrganizedSection = (generateEfilingLetterConfig.find(x => x.name === 'Show Organise Documents')).value;
            }
            else {
                this.showCoverLetterSection = false;
                this.showSupportLetterSection = false;
                this.showOrganizedSection = false;
            }
        }
        else {
            if (this.stepDetails && this.stepDetails.additionalConfig && JSON.parse(this.stepDetails.additionalConfig).generateLetterConfig) {
                let generateLetterConfig = JSON.parse(this.stepDetails.additionalConfig).generateLetterConfig;
                this.showCoverLetterSection = (generateLetterConfig.find(x => x.name === 'Show Cover Letter')).value;
                this.showSupportLetterSection = (generateLetterConfig.find(x => x.name === 'Show Support Letter')).value;
                this.showOrganizedSection = (generateLetterConfig.find(x => x.name === 'Show Organise Documents')).value;
            }
            else {
                this.showSupportLetterSection = this.primaryData.visatype === 'APPLADCARDNONIM' || this.primaryData.immigrationClassification === "APPLADCARDIMM" ? false : true;
                this.showOrganizedSection = this.primaryData.visatype === 'APPLADCARDNONIM' || this.primaryData.immigrationClassification === "APPLADCARDIMM" ? false : true;
            }
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
LetterGenerationLibraryComponent.ɵfac = function LetterGenerationLibraryComponent_Factory(t) { return new (t || LetterGenerationLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i2.DirtyFormGuard), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
LetterGenerationLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LetterGenerationLibraryComponent, selectors: [["letter-generation-library"]], viewQuery: function LetterGenerationLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PlaceHolderDirective, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.placeHolder = _t.first);
    } }, inputs: { primaryData: "primaryData", isWizard: "isWizard", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose" }, decls: 24, vars: 19, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row pt-1 d-flex align-items-center", 4, "ngIf"], [1, "row"], [1, "col-md-12", "p-0"], [4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [3, "ngClass"], [1, "row", "mt-2", 3, "ngClass"], [1, "card", "card-min", "no-border"], [1, "im-card-tab-menu"], [1, "im-list-group", "leftSidebar", "ml-0"], [1, "im-list-group-item", 3, "ngClass", "click"], ["class", "im-list-group-item", 3, "ngClass", "click", 4, "ngIf"], [1, "col-md", "pl-0", "pr-0"], ["dynamicComponentPlaceHolder", ""], [3, "ngClass", 4, "ngIf"], ["class", "row pt-3 border-top", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "page-header"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], ["class", "col-auto px-0 firstPortion", 4, "ngIf"], ["class", "col-auto pr-0 pl-2 secondPortion", 4, "ngIf"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row", "pt-1", "d-flex", "align-items-center"], ["class", "col-md-8 step-title p-0", 4, "ngIf"], [1, "page-header", "pl-3", "headerPortion"], [1, "m-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], [3, "inputDetails", "primaryData", "sectionCode"], ["mat-stretch-tabs", "false", "mat-align-tabs", "start", 3, "selectedTabChange"], ["label", "Generate Forms"], [3, "inputData", 4, "ngIf"], ["label", "Cover Letter"], [3, "primaryData", 4, "ngIf"], ["label", "Support Letter"], [3, "inputData"], [3, "primaryData"], [1, "row", "pt-3", "border-top"], [1, "col-md-6"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "stepDetails", "visaType", "type", "showPreviousStepBtn", "showNextStepBtn"], [2, "color", "#6c6666", "font-size", "14px"], [1, "pi", "pi-info-circle", "pr-2", 2, "color", "#19A0DA"]], template: function LetterGenerationLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, LetterGenerationLibraryComponent_div_1_Template, 11, 3, "div", 1);
        i0.ɵɵtemplate(2, LetterGenerationLibraryComponent_div_2_Template, 7, 3, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, LetterGenerationLibraryComponent_ng_container_5_Template, 2, 4, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, LetterGenerationLibraryComponent_p_divider_6_Template, 1, 0, "p-divider", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtemplate(8, LetterGenerationLibraryComponent_ng_container_8_Template, 2, 3, "ng-container", 5);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "a", 12);
        i0.ɵɵlistener("click", function LetterGenerationLibraryComponent_Template_a_click_13_listener() { return ctx.handleFormsGeneration(); });
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15, "Forms");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, LetterGenerationLibraryComponent_a_16_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(17, LetterGenerationLibraryComponent_a_17_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(18, LetterGenerationLibraryComponent_a_18_Template, 3, 4, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 14);
        i0.ɵɵtemplate(20, LetterGenerationLibraryComponent_ng_template_20_Template, 0, 0, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, LetterGenerationLibraryComponent_div_21_Template, 8, 6, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, LetterGenerationLibraryComponent_ng_container_22_Template, 2, 1, "ng-container", 5);
        i0.ɵɵtemplate(23, LetterGenerationLibraryComponent_div_23_Template, 4, 0, "div", 17);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", !ctx.isWizard ? "main-body footer-adjust" : "main-body-wizard");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c2, ctx.isWizard));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c1, ctx.selectedItem === 0, ctx.selectedItem !== 0));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showCoverLetterSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSupportLetterSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOrganizedSection);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLastTab && !ctx.isWizard && ctx.primaryData.visatype != "APPLADCARDNONIM" && ctx.primaryData.immigrationClassification != "APPLADCARDIMM");
    } }, directives: [i6.NgIf, i6.NgClass, i7.PlaceHolderDirective, i8.StepStatusUpdateComponentLibraryComponent, i9.MaximizeDialogLibraryComponent, i10.AssigningTaskLibraryComponent, i11.Divider, i12.LastUpdateLibraryComponent, i13.MatTabGroup, i13.MatTab, i14.GenerateFormsNewLibraryComponent, i15.CoverLetterLibraryComponent, i16.SupportLetterLibraryComponent], styles: [".step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:14px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.activeItem[_ngcontent-%COMP%]{color:#2196f3!important;cursor:pointer!important}.inActiveItem[_ngcontent-%COMP%]{color:#4d4848!important;cursor:pointer!important}.leftSidebar[_ngcontent-%COMP%]{margin-left:0!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]{background-color:#e1dede!important;margin-right:0!important;padding:10px 0 0!important;width:200px!important;font-size:14px!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-bottom:10px!important}.im-list-group-item.active[_ngcontent-%COMP%]{border-right:4px solid #19a0da!important}div.im-card-tab-menu[_ngcontent-%COMP%]   div.im-list-group[_ngcontent-%COMP%] > a.active[_ngcontent-%COMP%]:after{margin-left:3px!important}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.btn-top-flex[_ngcontent-%COMP%]{vertical-align:text-top}.itemListActive[_ngcontent-%COMP%]{color:#00f}.itemListDeactive[_ngcontent-%COMP%]{color:red}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto;padding-right:0!important}.leftSidebar[_ngcontent-%COMP%]{border:none!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]{background-color:#fff!important;font-size:16px!important;padding:15px 10px!important}.im-list-group-item[_ngcontent-%COMP%]{padding:15px 10px 15px 0!important;border-bottom:.5px solid hsla(0,0%,43.9%,.3)!important;font-weight:600!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none!important;padding:0!important;margin:0!important}.card[_ngcontent-%COMP%]{border-right:.5px solid hsla(0,0%,43.9%,.3)!important;padding-right:15px}.itemListActive[_ngcontent-%COMP%]{color:#01a0da!important}.headerPortion[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#002e83;font-weight:600}.displayNone[_ngcontent-%COMP%]{display:none!important}.main-body-wizard[_ngcontent-%COMP%]{width:100%;overflow:auto;padding-right:0!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'letter-generation-library',
                templateUrl: 'letter-generation-library.component.html',
                styleUrls: ['letter-generation-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i0.ComponentFactoryResolver }, { type: i2.DirtyFormGuard }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { placeHolder: [{
            type: ViewChild,
            args: [PlaceHolderDirective, { static: true }]
        }], primaryData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], simplifyH1b: [{
            type: Input
        }] }); })();

// import { GenerateFormsLibraryModule } from 'generate-forms-library';
class LetterGenerationLibraryModule {
}
LetterGenerationLibraryModule.ɵfac = function LetterGenerationLibraryModule_Factory(t) { return new (t || LetterGenerationLibraryModule)(); };
LetterGenerationLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LetterGenerationLibraryModule });
LetterGenerationLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            PlaceHolderLibraryModule,
            OrganizeDocumentsLibraryModule,
            DocumentChecklistNewLibraryModule,
            CoverLetterLibraryModule,
            SupportLetterLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            MatTabsModule,
            GenerateFormsNewLibraryModule
            // GenerateFormsLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LetterGenerationLibraryModule, { declarations: [LetterGenerationLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        PlaceHolderLibraryModule,
        OrganizeDocumentsLibraryModule,
        DocumentChecklistNewLibraryModule,
        CoverLetterLibraryModule,
        SupportLetterLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        MatTabsModule,
        GenerateFormsNewLibraryModule
        // GenerateFormsLibraryModule
    ], exports: [LetterGenerationLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LetterGenerationLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    PlaceHolderLibraryModule,
                    OrganizeDocumentsLibraryModule,
                    DocumentChecklistNewLibraryModule,
                    CoverLetterLibraryModule,
                    SupportLetterLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    MatTabsModule,
                    GenerateFormsNewLibraryModule
                    // GenerateFormsLibraryModule
                ],
                exports: [LetterGenerationLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of letter-generation-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LetterGenerationLibraryComponent, LetterGenerationLibraryModule, LetterGenerationLibraryService };
//# sourceMappingURL=letter-generation-library.js.map
